import type React from 'react'
import { DarkModeToggle } from '../components/DarkModeToggle'
import { SiteFooter } from '../components/SiteFooter'

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="theme-bg relative flex min-h-dvh flex-col p-2">
      <div className="absolute top-4 right-4 z-10">
        <DarkModeToggle />
      </div>
      {/* main wraps only the auth card so the footer below keeps its own
          contentinfo landmark - a footer nested inside main loses it. */}
      <main className="theme-surface flex grow items-center justify-center p-6 lg:rounded-lg lg:p-10">
        {children}
      </main>
      <SiteFooter className="px-6 lg:px-10" />
    </div>
  )
}
